import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import VueCookies from 'vue-cookies';
import i18n from './i18n'
import LoadScript from 'vue-plugin-load-script';
import store from './vueStore';

Vue.use(LoadScript);

Vue.config.productionTip = false
Vue.use(Vuelidate);

Vue.use(VueCookies);



require("@/styles/global.scss");

Vue.loadScript("/js/jquery-3.4.1.slim.min.js")
    .then(() => {
        // Vue.loadScript("/js/popper.min.js")
        Vue.loadScript("/js/bootstrap.bundle.min.js")
    })
    .catch(() => {
        // Failed to fetch script
    });


new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')

